module.exports = __webpack_public_path__ + "img/royal-image-new.15861fd1.png";